module.exports = __webpack_public_path__ + "img/kosmos-wma-family.8be929d9.jpg";